/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./peopleChange.vue?vue&type=template&id=ccbe9a34&scoped=true&"
import script from "./peopleChange.vue?vue&type=script&lang=js&"
export * from "./peopleChange.vue?vue&type=script&lang=js&"
import style0 from "./peopleChange.vue?vue&type=style&index=0&id=ccbe9a34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbe9a34",
  null
  
)

export default component.exports